import React from 'react';

import { CityContextType, CityContext } from './CityContext';

export const CityContextProvider = ({
  value,
  children,
}: {
  value: CityContextType;
  children: React.ReactNode;
}) => {
  return <CityContext.Provider value={value}>{children}</CityContext.Provider>;
};
